import styled from 'styled-components';
import Theme from '../../../styles/models/theme';
import Button from '../../atoms/Buttons/CommonBtn';

export const Container = styled.button<{theme: Theme}>`
  width: 100%;
  background-color: ${({theme}) => theme.white};
  padding: 16px;
  border-width: 0px;

  &:active {
    opacity: 0.8;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 5px;
`;

export const NameText = styled.text<{theme: Theme}>`
  font-weight: bold;
  font-size: 18px;
  color: ${({theme}) => theme.secondary};
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LightText = styled.text<{
  theme: Theme;
  width?: string;
  align?: string;
}>`
  font-weight: normal;
  font-size: 14px;
  color: ${({theme}) => theme.grayText};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${({width}) => (width ? `${width}%` : '50%')};
  text-align: ${({align}) => align || 'right'};
`;

export const BadgeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalButton = styled(Button)<{theme: Theme; type?: string}>`
  width: 30%;
  margin-left: 5px;
  margin-right: 5px;
  border-width: ${({type}) => (type === 'cancel' ? '2px' : '0')};
  border-style: solid;
  border-color: ${({theme}) => theme.secondary};
  background-color: ${({theme, type}) =>
    type === 'cancel' ? theme.white : null};
  display: flex;
  justify-content: center;
  align-items: center;
`;
